import { render, staticRenderFns } from "./ProjectManage.vue?vue&type=template&id=27e55418&"
import script from "./ProjectManage.vue?vue&type=script&lang=js&"
export * from "./ProjectManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports